import script from "./PersonalisationLandingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonalisationLandingPage.vue?vue&type=script&setup=true&lang=ts"

import "./PersonalisationLandingPage.vue?vue&type=style&index=0&id=fee6d030&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fee6d030"]])

export default __exports__